import { hexToRgb, pickOnColor } from '@/utils/contrast'

/**
 * Block/column `css` is applied inline on its wrapper, but columns that paint
 * their own surface (content, cta) would hide it behind the tenant primary.
 * This exposes the wrapper's bg as `--block-bg` / `--block-on-bg` so they can
 * use it instead. Spread onto the wrapper's style; a nearer wrapper (column)
 * overrides a farther one (block).
 */
export function getBackgroundVars(css: unknown): Record<string, string> {
  const style = (css || {}) as Record<string, unknown>

  // Both keys can be present; the browser paints whichever comes last in the
  // inline style, so match that to keep columns in sync with the wrapper.
  const bgKey = Object.keys(style)
    .filter((key) => (key === 'backgroundColor' || key === 'background') && typeof style[key] === 'string' && style[key])
    .pop()
  if (!bgKey) return {}

  const bg = style[bgKey] as string
  const vars: Record<string, string> = { '--block-bg': bg }
  if (hexToRgb(bg)) vars['--block-on-bg'] = pickOnColor(bg)

  return vars
}
